import React from 'react';
import { Box, Button, VStack, Text, HStack, useColorModeValue, Divider, Tooltip } from "@chakra-ui/react";
import { Link, useLocation } from 'react-router-dom';
import {
  FaUserAlt, FaChartBar, FaUserFriends, FaUniversity, FaRegUser,
  FaUsersCog, FaLayerGroup, FaListAlt, FaCogs, FaClipboard, FaFileAlt,
} from "react-icons/fa";
import PrivateSidebarLayout from '../Common/PrivateSidebarLayout';
import { useTenant } from "../Routers/TenantContextProvider";
import { usePlatformSidebar } from "../Common/PrivateSidebarContext";

const AdminSideBar = () => {
  const { tenant } = useTenant();
  const { isCollapsed } = usePlatformSidebar();
  const location = useLocation();

  const hoverBg = useColorModeValue("gray.100", "gray.700");

  const renderNavLink = (to: string, label: string, icon: React.ReactElement) => {
    const isActive = location.pathname === to;

    const button = (
      <Button
        as={Link}
        to={to}
        justifyContent={isCollapsed ? "center" : "flex-start"}
        variant="ghost"
        size="sm"
        pl={isCollapsed ? 0 : 4}
        py={5}
        borderRadius="lg"
        bg={isActive ? hoverBg : "transparent"}
        _hover={{ bg: hoverBg }}
        fontWeight={isActive ? "semibold" : "medium"}
        w="100%"
      >
        <HStack spacing={isCollapsed ? 0 : 3}>
          {icon}
          {!isCollapsed && <Text fontSize="sm">{label}</Text>}
        </HStack>
      </Button>
    );

    return isCollapsed ? (
      <Tooltip label={label} placement="right" hasArrow>
        {button}
      </Tooltip>
    ) : button;
  };

  return (
    <PrivateSidebarLayout>
      <Box px={isCollapsed ? 1 : 3} py={4} mt={10}>
        <VStack align="stretch" spacing={1}>
          {renderNavLink(`/platform/${tenant?.tenant_slug}/app/register-enrolled-student`, "Student Registration", <FaUserAlt />)}
          <Divider my={1} />
          {renderNavLink(`/platform/${tenant?.tenant_slug}/app/course-manager`, "Courses", <FaChartBar />)}
          <Divider my={1} />
          {renderNavLink(`/platform/${tenant?.tenant_slug}/app/batch-management`, "Batches", <FaUserFriends />)}
          <Divider my={1} />
          {renderNavLink(`/platform/${tenant?.tenant_slug}/app/student-manager`, "Students", <FaUniversity />)}
          <Divider my={1} />
          {renderNavLink(`/platform/${tenant?.tenant_slug}/app/tutor-manager`, "Tutors", <FaRegUser />)}
          <Divider my={1} />
          {renderNavLink(`/platform/${tenant?.tenant_slug}/app/user-management`, "User Management", <FaUsersCog />)}
          <Divider my={1} />
          {renderNavLink(`/platform/${tenant?.tenant_slug}/app/question-set-category-manager`, "QSet Categories", <FaLayerGroup />)}
          <Divider my={1} />
          {renderNavLink(`/platform/${tenant?.tenant_slug}/app/question-set-manager`, "Question Sets", <FaListAlt />)}
          <Divider my={1} />
          {renderNavLink(`/platform/${tenant?.tenant_slug}/app/tenant-cms-mapping`, "CMS Settings", <FaCogs />)}
          <Divider my={1} />
          {renderNavLink(`/platform/${tenant?.tenant_slug}/app/exam-manager`, "Exams", <FaClipboard />)}
          <Divider my={1} />
          {renderNavLink(`/platform/${tenant?.tenant_slug}/app/practice-set-manager`, "Practice Sets", <FaFileAlt />)}
        </VStack>
      </Box>
    </PrivateSidebarLayout>
  );
};

export default AdminSideBar;